import React, { useContext, useMemo } from 'react'
import { PlayerProfileContext } from '../../Context'
import { Box } from '../../Components/Layout'
import { SectionHeading } from '../../Components/Headers'
import { GameLogs } from './components'
import { ValuesInRowContainer, SeasonSelector } from './components'
import { SeasonStatsTable } from './components/Stats/AllSeasonsStats/SeasonStatsTable'
import { CurrentSeasonStats } from './components/Stats/CurrentSeason/CurrentSeasonStats'
import { AdUnit } from '../../Components/Ads/AdUnit'

export const StatsTab: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { player, getStats, career, getPlayerLeague } = useContext(PlayerProfileContext)!
  const careerStats = useMemo(() => {
    if (!career) return []
    return getStats('career', false, career)
  }, [career])
  const league = getPlayerLeague('stats')

  return (
    <>
      <Box>
        <SeasonSelector
          allYears={player?.allYears}
          isActive={player?.status === 'current'}
        />

        <CurrentSeasonStats league={league} />

        <SectionHeading lowMargin>
          <strong>Game Stats</strong>
        </SectionHeading>
        <GameLogs />
      </Box>
      <AdUnit bannerType="bannerSecond" aria-label="Player stats ad second" />

      {player?.allSeasonStats && player.allSeasonStats.length > 0 && (
        <>
          <Box>
            <SectionHeading lowMargin>
              <strong>All Seasons</strong>
            </SectionHeading>
            <SeasonStatsTable />
          </Box>
        </>
      )}

      {careerStats && careerStats.length > 0 && (
        <Box>
          <SectionHeading>
            <strong>Career Stats</strong>
          </SectionHeading>
          <ValuesInRowContainer noBorder values={careerStats} switchOn="md" />
        </Box>
      )}
      <AdUnit bannerType="bannerThird" aria-label="Player stats ad third" />
    </>
  )
}
